module.exports = __webpack_public_path__ + "6efac060b079d5549ec0c49bfb950893.jpg";